import moment, { type MomentInput, type Moment } from 'moment';

const isToday = (date: Moment) => {
  const now = moment();
  return (
    date.date() === now.date() &&
    date.month() === now.month() &&
    date.year() === now.year()
  );
};

export const getNow = (): string => moment().toISOString();

export const formatDate = (date: MomentInput): string => {
  const d = moment.utc(date).local();

  if (!isToday(d)) {
    return d.format('D MMM');
  }

  return d.format('H:mm');
};

export const shortFormat = (date: MomentInput): string => {
  return moment.utc(date).local().format('D.MM.YY');
};

export const formatDateWithoutSeconds = (date: MomentInput): string => {
  return moment(date).format('DD MMMM YYYY LT');
};

export const checkIsISODate = (str: string) => {
  return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(str);
};
